<template>
  <editor
    v-if="item"
    :structure="orderedUnpublishedStructure"
    :projectId="item.project_id"
    :dragElements="dragElements"
    :showTabs="false"
    :limitEditing="true"
    :shouldIncludeSubmit="true"
    :editorName="'ExternalForm'"
    @save="save"
    @publish="publish"
  />
</template>
<script>
import ProjectApi from "@/api/Project.js";
import Drag from "@/classes/Drag";
import Mask from "@/classes/Mask";
import Editor from "@/components/helpers/DragNDrop/Editor";
import Ui from "@/classes/Ui";

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    item_saved: {
      type: Object,
      required: true
    }
  },
  components: {
    Editor
  },
  data() {
    return {
      dragElements: [Drag.generateDefaultElements("external_form")]
    };
  },
  computed: {
    dragEditorEdited() {
      return this.$store.getters.getDragEditorEdited;
    },
    orderedUnpublishedStructure() {
      let structure = this.item.unpublished_structure;
      let clonedStructure = _.cloneDeep(structure);
      let fields = Mask.listFields(structure);
      let array = [...Object.values(fields)];
      // Sort by position value of objects
      array.sort(function(a, b) {
        return Number(a.position) - Number(b.position);
      });
      return array;
    }
  },
  async mounted() {
    await this.setLeadMaskElements();
    this.setupHeader();
  },
  beforeRouteLeave(to, from, next) {
    if (this.dragEditorEdited) {
      let shouldLeave = window.confirm(
        this.$t("ui.drag_editor.popup.unsaved_changes")
      );
      if (shouldLeave) {
        this.setEdited(false)
        this.removeHeaderButtons()
      }
      next(shouldLeave);
    } else {
      this.removeHeaderButtons();
      next();
    }
  },
  methods: {
    removeHeaderButtons() {
      Ui.setHeaderButtons([]);
    },
    setupHeader() {
      Ui.setHeaderButtons([
        {
          name: "external_form_save",
          action: "external_form.save",
          classes: "btn-tertiary"
        },
        {
          name: "external_form_publish",
          action: "external_form.publish",
          classes: "btn-primary"
        }
      ]);
    },
    save(structureArray) {
      let structure = Drag.arrayToStructure(_.cloneDeep(structureArray));
      this.item.unpublished_structure = structure;
      this.$emit("update", this.item);
      this.setEdited(false);
    },
    publish(structureArray) {
      let structure = Drag.arrayToStructure(structureArray);
      this.item.unpublished_structure = structure;
      this.item.structure = structure;
      this.$emit("update", this.item);
      this.setEdited(false);
    },
    setEdited(bool) {
      this.$store.commit("SET_DRAG_EDITOR_EDITED", bool);
    },
    // Fetch lead mask elements for editor
    async setLeadMaskElements() {
      if (!this.item.project_id) {
        return [];
      }
      let projectApi = new ProjectApi();
      let res = await projectApi.lead_mask(this.item.project_id);
      let fields = Mask.listFields(res.structure);
      // Set some values that are needed by the editor
      let title = this.$t("ui.drag_editor.dragElements.leadMask");
      fields.forEach(field => {
        field.shouldBeDeleted = true;
        field.parentTitle = title;
      });
      // Remove existing if it is present
      if (
        this.dragElements.some(o => {
          return o.title === title;
        })
      ) {
        // JavaScript ......
        delete this.dragElements[
          this.dragElements.indexOf(
            this.dragElements.find(o => {
              if (o) {
                return o.title === title
              }
            })
          )
        ];
      }
      this.dragElements.push({
        title: title,
        shouldBeFiltered: true,
        items: fields
      });
    }
  },
  watch: {
    "item.project_id": {
      deep: true,
      handler() {
        this.setLeadMaskElements();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// ExternalFormEditor.vue?863e69e4